export const roomType = {
  ROOM: 'ROOM',
  APPARTMENT: 'APPARTMENT',
  HOME: 'HOME',
} as const;

export type RoomType = (typeof roomType)[keyof typeof roomType];
